import { Component, effect, signal } from "@angular/core";
import { AvioblueChatbotComponent } from "atl-chatbot-lib";
import { CommonModule } from "@angular/common";
import { embedPrimaryColor } from "./embed-options";

@Component({
    selector: "app-root",
    imports: [AvioblueChatbotComponent, CommonModule],
    templateUrl: "./app.html",
    styleUrl: "./app.scss",
})
export class App {
    protected readonly title = signal("atl-chatbot");

    /**
     * The embedding page's colour, on this application's own root as well as the widget's.
     *
     * The closed bubble is drawn by this application and not by the widget, so it sits outside the
     * widget's themed scope and would otherwise keep a colour of its own while everything inside
     * took the host's.
     */
    protected readonly primaryColor = embedPrimaryColor();
    protected readonly minimized = signal(false);

    constructor() {
        // Notify the parent window to resize the iframe whenever the minimized state changes
        effect(() => {
            const isMinimized = this.minimized();
            if (window.parent && window.parent !== window) {
                window.parent.postMessage({ type: "resize", state: isMinimized ? "minimized" : "floating" }, "*");
            }
        });
    }
}
